import { intertextDetail } from '@/api/intertext';
import { useI18n } from 'vue-i18n';

type TranslateFn = ReturnType<typeof useI18n>['t'];

// Mapping of translation labels (category_a) to database entries (Altarabische Dichtung)
const categoryTranslationKeys: Record<string, string> = {
  'Altarabische Dichtung': 'category_a',
  'Hebräische Bibel': 'category_b',
  'Pseudepigraphen und Apokrypha der Hebräischen Bibel': 'category_c',
  'Neues Testament': 'category_d',
  'Pseudepigrapha und Apokrypha des Neuen Testaments': 'category_e',
  'Talmud, Midrasch und Targum': 'category_f',
  'Klassische Autoren, griechisch-römische und byzantinische Historiker': 'category_g',
  'Griechische, Lateinische und Syrische Patristik': 'category_h',
  'Christliche monastische und asketische Literatur': 'category_i',
  'Kirchenrecht und Synodenbeschlüsse': 'category_j',
  'Gebete, liturgische Texte und religiöse Formeln': 'category_k',
  'Inschriften, Münzen, Papyri, Amulette, Siegel und Gemmen': 'category_l',
  'Altorientalische Texte': 'category_m',
  'Zoroastrische Texte': 'category_n',
  'Manichäische Texte': 'category_o',
};

export default function translateIntertextCategory(
  t: TranslateFn,
  name?: string,
): string {
  if (!name || name === 'undefined' || name === 'null') {
    const translated = t('intertext.tuk_no_category');
    return translated === 'intertext.tuk_no_category'
      ? '(Not yet assigned a category)'
      : translated;
  }

  const key = categoryTranslationKeys[name];
  if (!key) {
    return name;
  }

  const translated = t(`intertext.${key}`);
  return !translated || translated === `intertext.${key}` ? name : translated;
}
